/** The Terms of Use and Privacy Policy live on the marketing website; the app only links to them. */
export const TERMS_URL = 'https://roadfootage.com/terms'
export const PRIVACY_URL = 'https://roadfootage.com/privacy'
